import { render } from "./StyleAccordion.vue?vue&type=template&id=0e91a317&scoped=true"
import script from "./StyleAccordion.vue?vue&type=script&lang=js"
export * from "./StyleAccordion.vue?vue&type=script&lang=js"

import "./StyleAccordion.vue?vue&type=style&index=0&id=0e91a317&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e91a317"]])

export default __exports__